export const acceptedVideoTypes = {
  'video/mp4': ['.mp4'],
  'video/webm': ['.webm'],
}
